import * as React from 'react'

import { type SortDirection, Table } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import type Review from 'modules/reviews/store/models/v2/Review'

interface HeaderProps {
  onSort: (attribute: string, direction: SortDirection) => void
  attribute: string
  direction: SortDirection
  form: Review
}

export default function Header({ form, onSort, attribute, direction }: HeaderProps) {
  return (
    <Table.Head>
      <Table.Row>
        <Table.SortableHeadCell
          key="reviewee"
          attribute="reviewee"
          onSort={onSort}
          sortAttribute={attribute}
          sortDirection={direction}
          colSpan={3}
        >
          {i18n.t('surveys.review.participants.table.header.reviewee')}
        </Table.SortableHeadCell>
        {!form.isAnonymous && (
          <Table.HeadCell colSpan={2}>
            {i18n.t('surveys.review.participants.table.header.reviewers')}
          </Table.HeadCell>
        )}
        <Table.HeadCell colSpan={2} ellipsis>
          {i18n.t('surveys.review.participants.table.header.completion')}
        </Table.HeadCell>
        <Table.HeadCell colSpan={2}>
          {i18n.t('surveys.review.participants.table.header.end_date')}
        </Table.HeadCell>
        <Table.HeadCell />
      </Table.Row>
    </Table.Head>
  )
}
